import styled from 'styled-components';

export const PageActions = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 40px 30px;

  @media (max-width: ${(props) => props.theme['media.mobile']}px) {
    padding: 0 10px 30px;
  }
`;

export const PageActionsLeft = styled.div`
  margin-right: auto;
`;

export const PageActionsRight = styled.div`
  margin-left: auto;
`;
